import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Screen from '../../Components/Screen'

import Header from './Components/Header'
import Table from './Components/Table'

const SubcontractorSubOrders = props => {

  const {
    componentDidMount,
  } = props

  useEffect(() => {
    componentDidMount()
  }, [])

  return (
    
    <Screen>

      <Header />

      <Table />

    </Screen>

  )

}

SubcontractorSubOrders.propTypes = {
  componentDidMount: PropTypes.func.isRequired,
}

export default SubcontractorSubOrders
